import { LibraryFilled, LibraryRegular, FluentIconsProps } from '@fluentui/react-icons';
import { GlobalLibraryFilled, GlobalLibraryRegular } from './GlobalLibrary';
import { LibraryLinkFilled, LibraryLinkRegular } from './LibraryLink';

export type TLibraryIconVariant = 'url' | 'qm' | 'default';

type TProps = FluentIconsProps & {
  variant: TLibraryIconVariant;
  filled: boolean;
};

/** Library icon with variant badge (link, globe, or plain). */
export const LibraryIcon = ({ variant, filled, ...iconProps }: TProps) => {
  const Icon =
    variant === 'url'
      ? filled
        ? LibraryLinkFilled
        : LibraryLinkRegular
      : variant === 'qm'
        ? filled
          ? GlobalLibraryFilled
          : GlobalLibraryRegular
        : filled
          ? LibraryFilled
          : LibraryRegular;
  return <Icon {...iconProps} />;
};
